import React from 'react';
import { FaBolt, FaMoon, FaRobot, FaCheckCircle, FaExclamationCircle } from 'react-icons/fa';
import './LandingStats.css';

const LandingStats = () => {
    return (
        <section className="landing-section landing-stats">
            <div className="landing-stats-header">
                <h2 className="section-title">Ne laissez plus d'argent sur la table</h2>
                <p className="section-subtitle">
                    Les agences et modèles qui utilisent Unbot surperforment le marché.
                </p>
            </div>

            <div className="stats-comparison-container">
                <div className="comparison-table">
                    <div className="table-header">
                        <div className="th-metric"></div>
                        <div className="th-competitor">Chatter Humain</div>
                        <div className="th-unbot">Unbot AI <FaBolt style={{ marginLeft: 6 }} /></div>
                    </div>

                    <div className="table-row">
                        <div className="td-metric">Temps de sommeil</div>
                        <div className="td-competitor">8h / nuit</div>
                        <div className="td-unbot">0 sec</div>
                    </div>
                    <div className="table-row">
                        <div className="td-metric">Pauses Café / Cigarette</div>
                        <div className="td-competitor">2h / jour</div>
                        <div className="td-unbot">0 sec</div>
                    </div>
                    <div className="table-row">
                        <div className="td-metric">Maladie / Vacances</div>
                        <div className="td-competitor">5 semaines / an</div>
                        <div className="td-unbot">Jamais</div>
                    </div>
                    <div className="table-row">
                        <div className="td-metric">Temps de réponse</div>
                        <div className="td-competitor">~5-10 min</div>
                        <div className="td-unbot highlight">Paramétrable (min 30s)</div>
                    </div>
                    <div className="table-row">
                        <div className="td-metric">Conversations simultanées</div>
                        <div className="td-competitor">Max 5</div>
                        <div className="td-unbot highlight">Illimité</div>
                    </div>
                    <div className="table-row">
                        <div className="td-metric">Vol de contenu</div>
                        <div className="td-competitor caution"><FaExclamationCircle /> Risque élevé</div>
                        <div className="td-unbot success"><FaCheckCircle /> Impossible</div>
                    </div>
                    <div className="table-row">
                        <div className="td-metric">Humeur</div>
                        <div className="td-competitor">Variable</div>
                        <div className="td-unbot">Toujours au top</div>
                    </div>
                </div>
            </div>

            <div className="stats-info-grid">
                <div className="info-item">
                    <div className="info-icon-circle"><FaBolt /></div>
                    <h3>+120%</h3>
                    <p>D'augmentation sur le taux de conversion fan.</p>
                </div>
                <div className="info-item">
                    <div className="info-icon-circle"><FaMoon /></div>
                    <h3>0 Pause</h3>
                    <p>Unbot travaille quand vous dormez. Aucune opportunité manquée.</p>
                </div>
                <div className="info-item">
                    <div className="info-icon-circle"><FaRobot /></div>
                    <h3>Superhumain</h3>
                    <p>Gère 1000+ conversations simultanées sans fatigue.</p>
                </div>
            </div>

            <p className="disclaimer">* Basé sur une moyenne de temps de réponse humain de 2-5 minutes.</p>
        </section>
    );
};

export default LandingStats;
